import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardActionArea, Typography, Grid } from '@mui/material';
import { Psychology, InsightsOutlined, Person } from '@mui/icons-material';

/**
 * Entry points to practice (#03), progress (#11/#12) and the profile.
 *
 * These also live in the header's account menu, but that menu is hidden below the `md`
 * breakpoint — and most students here are on a phone. Without these cards the three
 * screens would be unreachable on exactly the devices most used to reach them.
 */

const LINKS = [
  {
    path: '/practice',
    icon: <Psychology />,
    title: 'Practice',
    blurb: 'Questions picked for your weak areas, with answers explained.'
  },
  {
    path: '/progress',
    icon: <InsightsOutlined />,
    title: 'My Progress',
    blurb: 'Your streak, badges and how your scores are moving.'
  },
  {
    path: '/profile',
    icon: <Person />,
    title: 'Profile',
    blurb: 'Your details, class and school.'
  }
];

const QuickLinks: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ mt: 3, mb: 1 }}>
      <Grid container spacing={2}>
        {LINKS.map((l) => (
          <Grid size={{ xs: 12, sm: 4 }} key={l.path}>
            <Card sx={{ height: '100%' }}>
              <CardActionArea
                onClick={() => navigate(l.path)}
                sx={{ p: 2, height: '100%', display: 'block' }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                  <Box sx={{ color: 'primary.main', display: 'flex' }}>{l.icon}</Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                    {l.title}
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {l.blurb}
                </Typography>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default QuickLinks;
